// Shared by upload admission and browser pickers. Office originals are retained;
// their extracted text is read through the same scoped file tools as PDFs.
export const BUSINESS_FILE_MIMES = Object.freeze({
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  tsv: 'text/tab-separated-values',
});
export const OFFICE_FILE_TYPES = Object.freeze([
  BUSINESS_FILE_MIMES.xlsx,
  BUSINESS_FILE_MIMES.docx,
  BUSINESS_FILE_MIMES.pptx,
]);
export const TEXT_FILE_TYPES = Object.freeze([
  'text/plain',
  'text/markdown',
  'text/csv',
  'application/json',
  BUSINESS_FILE_MIMES.tsv,
]);
export const FILE_TYPES = Object.freeze([
  ...TEXT_FILE_TYPES,
  'application/pdf',
  ...OFFICE_FILE_TYPES,
]);
export const BUSINESS_FILE_ACCEPT = Object.keys(BUSINESS_FILE_MIMES)
  .map((extension) => `.${extension}`)
  .join(',');
